import { MasterDetailListEntry } from "@sdbn/common";

export enum AutomationRuleType {
    ASSIGNMENT = 'ASSIGNMENT', UMBRUECKUNG = 'UMBRUECKUNG', TRAILER_SWAP = 'TRAILER_SWAP'
}

export class AutomationRuleStation {

    id: number;
    name: string;
    stationId: number;
    index: number;
    deleted = false;

    constructor(ruleStation?: any) {
        if (ruleStation != null) {
            this.id = ruleStation.id;
            this.name = ruleStation.name;
            this.stationId = ruleStation.stationId;
            this.index = ruleStation.index;
            this.deleted = ruleStation.deleted;
        }
    }

}

export class AutomationRule implements MasterDetailListEntry {

    id: number;
    index: number;
    name: string;

    constructor(rule?: any) {
        if (rule != null) {
            this.id = rule.id;
            this.index = rule.index;
            this.name = rule.name;
        }
    }

    public get listTitle(): string {
        return this.name;
    }

    public get listTitleDictionaryKey(): string {
        return null;
    }

    public get listSubTitle(): string {
        return null;
    }

    public get groupIdentifier(): String {
      return null;
    }

    public get childs() : Array<MasterDetailListEntry> {
      return null;
    }

}

export class AutomationRuleIndex {

    id: number;
    index: number;

    constructor(id: number, index: number) {
        this.id = id;
        this.index = index;
    }
}

export class AutomationRuleDetails {

    id: number;
    index: number;
    name: string;
    carrier: string;
    numberPlate: string;
    orderReference: string;
    stations = new Array<AutomationRuleStation>();
    type: AutomationRuleType;
    onlyPlanned: boolean;
    deleted = false;

    constructor(rule?: any) {
        if (rule != null) {
            this.id = rule.id;
            this.index = rule.index;
            this.name = rule.name;
            this.carrier = rule.carrier;
            this.numberPlate = rule.numberPlate;
            this.orderReference = rule.orderReference;
            this.type = rule.type;
            this.onlyPlanned = rule.onlyPlanned;
            this.deleted = rule.deleted;

            if (rule.stations != null) {
                for (const station of rule.stations) {
                    this.stations.push(new AutomationRuleStation(station));
                }
            }
        }
    }
}

export class Station {
    id: number;
    name: string;
    description: string;
    stationType: string;

    constructor(station: any) {
        this.id = station.id;
        this.name = station.name;
        this.description = station.description;
        this.stationType = station.stationType;
    }
}


